// import { useState, useEffect, useCallback, useRef, useMemo } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import "../css/AddTourProgram.css";
// import { BASE_URL } from "../config";
// import { getAuthHeaders } from "../services/useAuth";
// import Loader from "../dist/Loader";
// import CustomButton from "./CustomButton";

// const ROLE_HIERARCHY = [
//   "superadmin",
//   "admin",
//   "coordinator",
//   "distributor",
//   "nsm",
//   "zsm",
//   "rsm",
//   "asm",
//   "tsm",
//   "ase",
//   "mr",
// ];

// const normalizeRole = (role = "") => {
//   if (!role) return "";
//   const roleStr = role.toString().trim().toLowerCase();
//   const roleMap = {
//     "team sales manager": "tsm",
//     tsm: "tsm",
//     "area sales executive": "ase",
//     ase: "ase",
//     "medical representative": "mr",
//     mr: "mr",
//     me: "mr",
//     "medical executive": "mr",
//     "regional sales manager": "rsm",
//     rsm: "rsm",
//     "area sales manager": "asm",
//     asm: "asm",
//     "zone sales manager": "zsm",
//     zsm: "zsm",
//     "national sales manager": "nsm",
//     nsm: "nsm",
//     coordinator: "coordinator",
//     admin: "admin",
//     superadmin: "superadmin",
//     distributor: "distributor",
//   };
//   return roleMap[roleStr] || roleStr;
// };
// // Inline remarks input component
// const RemarksCell = ({ value, onChange, disabled }) => (
//   <td style={{ minWidth: 200, padding: "4px 6px" }}>
//     <input
//       type="text"
//       className="tourpage-remarks-input"
//       value={value || ""}
//       onChange={(e) => onChange(e.target.value)}
//       disabled={disabled}
//       placeholder="Enter remarks..."
//     />
//   </td>
// );

// const TourProgramModified = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const abortControllerRef = useRef(null);
//   const mountedRef = useRef(true);

//   const [currentUser, setCurrentUser] = useState(null);
//   const [originalData, setOriginalData] = useState({});
//   const [formData, setFormData] = useState({});
//   const [routes, setRoutes] = useState({});
//   const [teamMembers, setTeamMembers] = useState([]);
//   const [previousRoutes, setPreviousRoutes] = useState([]);
//   const [previousRoutesByEmployee, setPreviousRoutesByEmployee] = useState({});
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [assignedCities, setAssignedCities] = useState({});
//   const [approvalStatus, setApprovalStatus] = useState("pending");
//   const [tourExists, setTourExists] = useState(false);

//   const employeeData = useMemo(() => {
//     const fromState = location.state?.employeeData;
//     const fromStorage = localStorage.getItem("employeeData");

//     let data = null;
//     if (fromState) {
//       data = fromState;
//     } else if (fromStorage) {
//       try {
//         data = JSON.parse(fromStorage);
//       } catch (e) {
//         console.error("Failed to parse employeeData from localStorage:", e);
//         data = {};
//       }
//     } else {
//       data = {};
//     }

//     const mappedData = {
//       id: data.emp_id || data.id || data.employee_id,
//       name: data.emp_name || data.name || data.employee_name,
//       designation: data.desi || data.designation || data.role_name,
//       role: data.role || data.desi || data.designation,
//       headquarter: data.hq || data.headquarter,
//       division: data.div || data.division,
//       state: data.state,
//       city: data.city,
//       final_joining_date:
//         data.doj || data.final_joining_date || data.date_of_joining,
//       selectedMonth: data.selectedMonth,
//       selectedYear: data.selectedYear,
//     };

//     if (fromState) {
//       localStorage.setItem("employeeData", JSON.stringify(mappedData));
//     }

//     return mappedData;
//   }, [location.state?.employeeData]);

//   const [userRole, setUserRole] = useState("");

//   useEffect(() => {
//     const determineRole = () => {
//       if (employeeData?.role) {
//         const normalized = normalizeRole(employeeData.role);
//         console.log(
//           "Using role from employeeData.role:",
//           employeeData.role,
//           "->",
//           normalized,
//         );
//         if (normalized && ROLE_HIERARCHY.includes(normalized)) {
//           return normalized;
//         }
//       }
//       if (location.state?.role) {
//         const normalized = normalizeRole(location.state.role);
//         console.log(
//           "Using role from location.state.role:",
//           location.state.role,
//           "->",
//           normalized,
//         );
//         if (normalized && ROLE_HIERARCHY.includes(normalized)) {
//           return normalized;
//         }
//       }
//       const storedRole = localStorage.getItem("role");
//       if (storedRole) {
//         const normalized = normalizeRole(storedRole);
//         console.log(
//           "Using role from localStorage:",
//           storedRole,
//           "->",
//           normalized,
//         );
//         if (normalized && ROLE_HIERARCHY.includes(normalized)) {
//           return normalized;
//         }
//       }
//       if (employeeData?.designation) {
//         const normalized = normalizeRole(employeeData.designation);
//         console.log(
//           "Using role from designation:",
//           employeeData.designation,
//           "->",
//           normalized,
//         );
//         if (normalized && ROLE_HIERARCHY.includes(normalized)) {
//           return normalized;
//         }
//       }
//       console.log("No valid role found");
//       return "";
//     };

//     const role = determineRole();
//     setUserRole(role);
//   }, [employeeData, location.state?.role]);

//   const isNewProgram = useMemo(() => {
//     return location.state?.isNewProgram || false;
//   }, [location.state?.isNewProgram]);

//   const isTsmOrAbove = useMemo(() => {
//     if (!userRole) {
//       console.log("No userRole found, defaulting to false");
//       return false;
//     }
//     const tsmIndex = ROLE_HIERARCHY.indexOf("tsm");
//     const currentIndex = ROLE_HIERARCHY.indexOf(userRole);
//     const isTsmOrAboveResult = currentIndex !== -1 && currentIndex <= tsmIndex;
//     return isTsmOrAboveResult;
//   }, [userRole]);

//   const {
//     employeeId,
//     selectedMonth,
//     selectedYear,
//     dateOfJoining,
//     monthYearDisplay,
//   } = useMemo(() => {
//     const empId = employeeData?.id;
//     const selMonth = employeeData?.selectedMonth || new Date().getMonth() + 1;
//     const selYear = employeeData?.selectedYear || new Date().getFullYear();

//     const getDateOfJoining = () => {
//       const dojDate =
//         employeeData?.final_joining_date ||
//         employeeData?.doj ||
//         employeeData?.date_of_joining;

//       if (!dojDate) return null;

//       try {
//         if (typeof dojDate === "string") {
//           const s = dojDate.trim();
//           const dmyDash = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
//           const dmySlash = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
//           let m = s.match(dmyDash) || s.match(dmySlash);
//           if (m) {
//             const day = Number(m[1]);
//             const month = Number(m[2]);
//             const year = Number(m[3]);
//             const date = new Date(year, month - 1, day);
//             if (!isNaN(date.getTime())) return date;
//             return null;
//           }
//           const iso = new Date(s);
//           if (!isNaN(iso.getTime())) return iso;
//           return null;
//         }
//         if (dojDate instanceof Date && !isNaN(dojDate.getTime()))
//           return dojDate;
//         if (typeof dojDate === "number") {
//           const date = new Date(dojDate);
//           return isNaN(date.getTime()) ? null : date;
//         }
//         return null;
//       } catch (error) {
//         console.error("Error parsing date of joining:", error, dojDate);
//         return null;
//       }
//     };

//     const doj = getDateOfJoining();

//     const monthYear = new Intl.DateTimeFormat("en", {
//       month: "short",
//       year: "numeric",
//     }).format(new Date(selYear, selMonth - 1));

//     return {
//       employeeId: empId,
//       selectedMonth: selMonth,
//       selectedYear: selYear,
//       dateOfJoining: doj,
//       monthYearDisplay: monthYear,
//     };
//   }, [employeeData]);

//   const normalizeMonthYear = useCallback((my) => {
//     if (!my) return my;
//     return my
//       .replace(/\bSept\.?\b/gi, "Sep")
//       .replace(/\s+/g, " ")
//       .trim();
//   }, []);

//   const daysArray = useMemo(() => {
//     const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
//     return Array.from({ length: daysInMonth }, (_, index) => {
//       const date = new Date(selectedYear, selectedMonth - 1, index + 1);

//       let isBeforeDoj = false;
//       if (dateOfJoining) {
//         const compareDate = new Date(
//           date.getFullYear(),
//           date.getMonth(),
//           date.getDate(),
//         );
//         const compareDoj = new Date(
//           dateOfJoining.getFullYear(),
//           dateOfJoining.getMonth(),
//           dateOfJoining.getDate(),
//         );
//         isBeforeDoj = compareDate < compareDoj;
//       }

//       return {
//         id: index + 1,
//         day: date.toLocaleDateString("en-US", { weekday: "long" }),
//         dateObj: date,
//         date: date.toLocaleDateString("en-GB", {
//           day: "2-digit",
//           month: "short",
//           year: "numeric",
//         }),
//         isBeforeDoj,
//       };
//     });
//   }, [selectedMonth, selectedYear, dateOfJoining]);

//   useEffect(() => {
//     mountedRef.current = true;
//     return () => {
//       mountedRef.current = false;
//       if (abortControllerRef.current) {
//         abortControllerRef.current.abort();
//       }
//     };
//   }, []);

//   const formatDateForAPI = useCallback((date) => {
//     if (!date) return "";
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   }, []);

//   useEffect(() => {
//     try {
//       const stored = localStorage.getItem("loggedInUser");
//       if (stored) {
//         setCurrentUser(JSON.parse(stored));
//       } else {
//         setCurrentUser({ username: "default_user" });
//       }
//     } catch (err) {
//       console.error("Error reading loggedInUser:", err);
//       setCurrentUser({ username: "default_user" });
//     }
//   }, []);

//   useEffect(() => {
//     if (userRole) {
//       localStorage.setItem("userRole", userRole);
//       console.log("Stored userRole in localStorage:", userRole);
//     }
//   }, [userRole]);

//   const fetchWithAuth = useCallback(async (url, options = {}) => {
//     if (!mountedRef.current) return null;

//     const controller = new AbortController();
//     abortControllerRef.current = controller;

//     const headers = {
//       ...getAuthHeaders(),
//       "Content-Type": "application/json",
//       ...(options.headers || {}),
//     };

//     try {
//       const resp = await fetch(url, {
//         ...options,
//         headers,
//         signal: controller.signal,
//       });

//       if (!resp.ok) {
//         const errData = await resp.json().catch(() => null);
//         const errMsg =
//           (errData && (errData.detail || errData.message)) ||
//           (errData ? JSON.stringify(errData) : `HTTP error ${resp.status}`);
//         throw new Error(errMsg);
//       }
//       return await resp.json();
//     } catch (err) {
//       if (err.name === "AbortError") {
//         return null;
//       }
//       console.error("fetchWithAuth:", err);
//       throw err;
//     }
//   }, []);

//   const fetchAssignedCities = useCallback(
//     async (empId) => {
//       if (!empId || !mountedRef.current) return [];
//       try {
//         const data = await fetchWithAuth(
//           `${BASE_URL}/api/assigned-cities/${empId}`,
//         );
//         return Array.isArray(data) ? data : [];
//       } catch (err) {
//         if (mountedRef.current) {
//           console.error("fetchAssignedCities:", err);
//         }
//         return [];
//       }
//     },
//     [fetchWithAuth],
//   );

//   const fetchRoutesForCity = useCallback(
//     async (cityId, empId) => {
//       const id = empId || employeeId;
//       if (!cityId || !id || !mountedRef.current) return [];
//       try {
//         const data = await fetchWithAuth(
//           `${BASE_URL}/api/routes/${id}/?city_id=${cityId}`,
//         );
//         return Array.isArray(data) ? data : [];
//       } catch (err) {
//         if (mountedRef.current) {
//           console.error("fetchRoutesForCity:", err);
//         }
//         return [];
//       }
//     },
//     [employeeId, fetchWithAuth],
//   );

//   const fetchPreviousRoutes = useCallback(async () => {
//     if (!employeeId || !mountedRef.current) return [];
//     try {
//       const data = await fetchWithAuth(
//         `${BASE_URL}/api/previous_routes/employee/${employeeId}`,
//       );
//       return Array.isArray(data) ? data : [];
//     } catch (err) {
//       if (mountedRef.current) {
//         console.error("fetchPreviousRoutes:", err);
//       }
//       return [];
//     }
//   }, [employeeId, fetchWithAuth]);

//   const fetchPreviousRoutesForEmployee = useCallback(
//     async (empId) => {
//       if (!empId || !mountedRef.current) return [];
//       try {
//         const data = await fetchWithAuth(
//           `${BASE_URL}/api/previous_routes/employee/${empId}`,
//         );
//         const arr = Array.isArray(data) ? data : [];
//         if (mountedRef.current) {
//           setPreviousRoutesByEmployee((prev) => ({
//             ...prev,
//             [Number(empId)]: arr,
//           }));
//         }
//         return arr;
//       } catch (err) {
//         if (mountedRef.current) {
//           console.error("fetchPreviousRoutesForEmployee:", err);
//         }
//         return [];
//       }
//     },
//     [fetchWithAuth],
//   );

//   const fetchTeamMembers = useCallback(async () => {
//     if (!employeeId || !mountedRef.current) return [];
//     try {
//       const params = new URLSearchParams();
//       const designation = employeeData?.designation?.toUpperCase() || "";
//       if (designation) params.set("designation", designation);
//       params.set("employee_id", String(employeeId));

//       const data = await fetchWithAuth(
//         `${BASE_URL}/api/employees-by-designation?${params.toString()}`,
//       );

//       const meetingOption = {
//         employee_id: 0,
//         employee_name: "Meeting",
//         first_name: "",
//         last_name: "",
//         designation: "",
//         city_name: "",
//         state_name: "",
//       };

//       const individualOption = {
//         employee_id: Number(employeeId),
//         employee_name: "individual",
//         first_name: "individual",
//         last_name: "individual",
//         designation: employeeData?.designation || "",
//         city_name: employeeData?.city || "",
//         state_name: employeeData?.state || "",
//       };

//       const apiEmployees = Array.isArray(data) ? data : [];

//       const map = new Map();
//       map.set(0, meetingOption);
//       map.set(Number(individualOption.employee_id), individualOption);

//       for (const emp of apiEmployees) {
//         const id = Number(emp.employee_id);
//         if (!Number.isFinite(id)) continue;
//         if (!map.has(id)) {
//           map.set(id, {
//             employee_id: id,
//             employee_name:
//               emp.employee_name ||
//               `${emp.first_name || ""} ${emp.last_name || ""}`.trim(),
//             first_name: emp.first_name || "",
//             last_name: emp.last_name || "",
//             designation: emp.designation || "",
//             city_name: emp.city_name || emp.city || "",
//             state_name: emp.state_name || emp.state || "",
//           });
//         }
//       }

//       return Array.from(map.values());
//     } catch (err) {
//       if (mountedRef.current) {
//         console.error("fetchTeamMembers:", err);
//       }
//       return [];
//     }
//   }, [employeeId, employeeData, fetchWithAuth]);

//   const debounceTimeoutRef = useRef({});

//   const handleWorkingWithChange = useCallback(
//     async (dayId, value) => {
//       if (!mountedRef.current) return;
//       const newWorkingWith = value === "" ? "" : Number.parseInt(value, 10);

//       if (debounceTimeoutRef.current[dayId]) {
//         clearTimeout(debounceTimeoutRef.current[dayId]);
//       }

//       const autoSecondary =
//         newWorkingWith &&
//         !Number.isNaN(newWorkingWith) &&
//         newWorkingWith !== 0 &&
//         newWorkingWith !== employeeId
//           ? newWorkingWith
//           : "";

//       setFormData((prev) => ({
//         ...prev,
//         [dayId]: {
//           ...prev[dayId],
//           workingWith: newWorkingWith,
//           city:
//             prev[dayId]?.workingWith !== newWorkingWith
//               ? ""
//               : prev[dayId]?.city || "",
//           route:
//             prev[dayId]?.workingWith !== newWorkingWith
//               ? ""
//               : prev[dayId]?.route || "",
//           secondaryWorkingWith: autoSecondary,
//         },
//       }));

//       if (autoSecondary) {
//         // Only fetch if not already cached
//         if (!previousRoutesByEmployee[Number(autoSecondary)]) {
//           fetchPreviousRoutesForEmployee(autoSecondary).catch(() => {});
//         }
//       }

//       if (!isTsmOrAbove) {
//         debounceTimeoutRef.current[dayId] = setTimeout(async () => {
//           if (!mountedRef.current) return;
//           try {
//             // Guard: skip if already cached
//             if (assignedCities[Number(employeeId)]?.length > 0) {
//               return;
//             }
//             const cities = await fetchAssignedCities(employeeId);
//             if (mountedRef.current) {
//               setAssignedCities((prev) => ({
//                 ...prev,
//                 [Number(employeeId)]: cities,
//               }));
//             }
//           } catch (err) {
//             if (mountedRef.current) {
//               console.error("handleWorkingWithChange:", err);
//             }
//           }
//         }, 300);
//       } else {
//         if (
//           newWorkingWith &&
//           !Number.isNaN(newWorkingWith) &&
//           newWorkingWith !== 0
//         ) {
//           debounceTimeoutRef.current[dayId] = setTimeout(async () => {
//             if (!mountedRef.current) return;
//             try {
//               // Guard: skip if already cached
//               if (assignedCities[Number(newWorkingWith)]?.length > 0) {
//                 return;
//               }
//               const cities = await fetchAssignedCities(newWorkingWith);
//               if (mountedRef.current) {
//                 setAssignedCities((prev) => ({
//                   ...prev,
//                   [Number(newWorkingWith)]: cities,
//                 }));
//               }
//             } catch (err) {
//               if (mountedRef.current) {
//                 console.error("handleWorkingWithChange:", err);
//               }
//             }
//           }, 300);
//         } else if (newWorkingWith === 0) {
//           debounceTimeoutRef.current[dayId] = setTimeout(async () => {
//             if (!mountedRef.current) return;
//             try {
//               // Guard: skip if already cached
//               if (assignedCities[0]?.length > 0) {
//                 return;
//               }
//               const cities = await fetchAssignedCities(employeeId);
//               if (mountedRef.current) {
//                 setAssignedCities((prev) => ({
//                   ...prev,
//                   [0]: cities,
//                 }));
//               }
//             } catch (err) {
//               if (mountedRef.current) {
//                 console.error("handleWorkingWithChange for Meeting:", err);
//               }
//             }
//           }, 300);
//         }
//       }
//     },
//     [
//       fetchAssignedCities,
//       employeeId,
//       fetchPreviousRoutesForEmployee,
//       isTsmOrAbove,
//       assignedCities,
//       previousRoutesByEmployee,
//     ],
//   );

//   const handleSecondaryWorkingWithChange = useCallback(
//     async (dayId, value) => {
//       if (!mountedRef.current) return;
//       const newSecondary = value === "" ? "" : Number.parseInt(value, 10);

//       setFormData((prev) => ({
//         ...prev,
//         [dayId]: {
//           ...prev[dayId],
//           secondaryWorkingWith: newSecondary,
//         },
//       }));

//       if (newSecondary && newSecondary !== 0) {
//         // Only fetch if not already cached
//         if (!previousRoutesByEmployee[Number(newSecondary)]) {
//           fetchPreviousRoutesForEmployee(newSecondary).catch(() => {});
//         }
//       }

//       if (!isTsmOrAbove) {
//         if (newSecondary && newSecondary !== 0) {
//           try {
//             // Guard: skip if already cached
//             if (!assignedCities[Number(employeeId)]?.length) {
//               const cities = await fetchAssignedCities(employeeId);
//               if (mountedRef.current) {
//                 setAssignedCities((prev) => ({
//                   ...prev,
//                   [Number(employeeId)]: cities,
//                 }));
//               }
//             }
//           } catch (err) {
//             if (mountedRef.current)
//               console.error(
//                 "handleSecondaryWorkingWithChange - fetchAssignedCities:",
//                 err,
//               );
//           }

//           const selectedCity = formData[dayId]?.city;
//           if (selectedCity) {
//             try {
//               const routeKey = `${Number(employeeId)}_${String(selectedCity)}`;
//               // Guard: skip if already cached
//               if (!routes[routeKey]?.length) {
//                 const cityRoutes = await fetchRoutesForCity(
//                   selectedCity,
//                   employeeId,
//                 );
//                 if (mountedRef.current) {
//                   setRoutes((prev) => ({
//                     ...prev,
//                     [routeKey]: cityRoutes,
//                   }));
//                 }
//               }
//             } catch (err) {
//               if (mountedRef.current)
//                 console.error(
//                   "handleSecondaryWorkingWithChange - fetchRoutesForCity:",
//                   err,
//                 );
//             }
//           }
//         }
//       } else {
//         if (newSecondary && newSecondary !== 0) {
//           try {
//             // Guard: skip if already cached
//             if (!assignedCities[Number(newSecondary)]?.length) {
//               const cities = await fetchAssignedCities(newSecondary);
//               if (mountedRef.current) {
//                 setAssignedCities((prev) => ({
//                   ...prev,
//                   [Number(newSecondary)]: cities,
//                 }));
//               }
//             }
//           } catch (err) {
//             if (mountedRef.current)
//               console.error(
//                 "handleSecondaryWorkingWithChange - fetchAssignedCities:",
//                 err,
//               );
//           }

//           const selectedCity = formData[dayId]?.city;
//           if (selectedCity) {
//             try {
//               const routeKey = `${Number(newSecondary)}_${String(selectedCity)}`;
//               // Guard: skip if already cached
//               if (!routes[routeKey]?.length) {
//                 const cityRoutes = await fetchRoutesForCity(
//                   selectedCity,
//                   newSecondary,
//                 );
//                 if (mountedRef.current) {
//                   setRoutes((prev) => ({
//                     ...prev,
//                     [routeKey]: cityRoutes,
//                   }));
//                 }
//               }
//             } catch (err) {
//               if (mountedRef.current)
//                 console.error(
//                   "handleSecondaryWorkingWithChange - fetchRoutesForCity:",
//                   err,
//                 );
//             }
//           }
//         }
//       }
//     },
//     [
//       fetchPreviousRoutesForEmployee,
//       fetchAssignedCities,
//       fetchRoutesForCity,
//       formData,
//       employeeId,
//       isTsmOrAbove,
//       assignedCities,
//       routes,
//       previousRoutesByEmployee,
//     ],
//   );

//   const handleCityChange = useCallback(
//     async (dayId, cityId, empId) => {
//       if (!mountedRef.current) return;

//       if (!cityId) {
//         setFormData((prev) => ({
//           ...prev,
//           [dayId]: {
//             ...prev[dayId],
//             city: "",
//             route: "",
//           },
//         }));
//         return;
//       }

//       if (debounceTimeoutRef.current[`city_${dayId}`]) {
//         clearTimeout(debounceTimeoutRef.current[`city_${dayId}`]);
//       }

//       setFormData((prev) => ({
//         ...prev,
//         [dayId]: {
//           ...prev[dayId],
//           city: cityId,
//           route: prev[dayId]?.city !== cityId ? "" : prev[dayId]?.route || "",
//         },
//       }));

//       if (!isTsmOrAbove) {
//         const routeKey = `${Number(employeeId)}_${String(cityId)}`;

//         debounceTimeoutRef.current[`city_${dayId}`] = setTimeout(async () => {
//           if (!mountedRef.current) return;
//           try {
//             // Guard: skip if already cached
//             if (routes[routeKey]?.length > 0) {
//               return;
//             }
//             const cityRoutes = await fetchRoutesForCity(cityId, employeeId);
//             if (mountedRef.current) {
//               setRoutes((prev) => ({
//                 ...prev,
//                 [routeKey]: cityRoutes,
//               }));
//             }
//           } catch (err) {
//             if (mountedRef.current) {
//               console.error("handleCityChange:", err);
//               toast.error("Failed to load routes for selected city");
//             }
//           }
//         }, 300);
//       } else {
//         const primary = formData[dayId]?.workingWith;
//         const secondary = formData[dayId]?.secondaryWorkingWith;
//         let targetEmployee = empId || primary || employeeId;
//         if (Number(primary) === Number(employeeId) && secondary) {
//           targetEmployee = secondary;
//         }

//         const routeKey = `${Number(targetEmployee)}_${String(cityId)}`;

//         debounceTimeoutRef.current[`city_${dayId}`] = setTimeout(async () => {
//           if (!mountedRef.current) return;
//           try {
//             // Guard: skip if already cached
//             if (routes[routeKey]?.length > 0) {
//               return;
//             }
//             const cityRoutes = await fetchRoutesForCity(cityId, targetEmployee);
//             if (mountedRef.current) {
//               setRoutes((prev) => ({
//                 ...prev,
//                 [routeKey]: cityRoutes,
//               }));
//             }
//           } catch (err) {
//             if (mountedRef.current) {
//               console.error("handleCityChange:", err);
//               toast.error("Failed to load routes for selected city");
//             }
//           }
//         }, 300);
//       }
//     },
//     [employeeId, formData, fetchRoutesForCity, isTsmOrAbove, routes],
//   );
//   const fetchInitialData = useCallback(async () => {
//     if (!employeeId || !mountedRef.current) {
//       setError("Employee data not available");
//       setIsLoading(false);
//       return;
//     }

//     setIsLoading(true);
//     setError(null);

//     try {
//       const [team, prevRoutes] = await Promise.all([
//         fetchTeamMembers(),
//         fetchPreviousRoutes(),
//       ]);

//       if (!mountedRef.current) return;

//       setTeamMembers(team);
//       setPreviousRoutes(prevRoutes);

//       if (isNewProgram) {
//         setFormData({});
//         setOriginalData({});
//         setIsLoading(false);
//         setApprovalStatus("pending");
//         return;
//       }

//       const normalizedMonthYear = normalizeMonthYear(monthYearDisplay);

//       const existing = await fetchWithAuth(
//         `${BASE_URL}/api/tour-programs/tour-monthly?employee_id=${employeeId}&monthYear=${encodeURIComponent(
//           normalizedMonthYear,
//         )}`,
//       );

//       if (!mountedRef.current) return;
//       if (
//         existing &&
//         Array.isArray(existing.entries) &&
//         existing.entries.length > 0
//       ) {
//         setTourExists(true);
//       } else {
//         setTourExists(false);
//       }
//       // Determine approval status
//       let status = "pending";
//       if (existing) {
//         if (existing.status) {
//           const statusLower = String(existing.status).toLowerCase();
//           if (statusLower === "approved") status = "approved";
//         } else if (existing.approved_detail?.status) {
//           const statusLower = String(
//             existing.approved_detail.status,
//           ).toLowerCase();
//           if (statusLower === "approved") status = "approved";
//         } else if (existing.approval_status) {
//           const statusLower = String(existing.approval_status).toLowerCase();
//           if (statusLower === "approved") status = "approved";
//         } else if (existing.is_approved === true) status = "approved";
//         else if (existing.approved === true) status = "approved";
//         else if (existing.approved_by && existing.approved_date)
//           status = "approved";
//       }

//       setApprovalStatus(status);

//       const initFormData = {};
//       const initOriginal = {};

//       // ── Deduplication sets ────────────────────────────────────────────────
//       // Always include the main employee so individual/Meeting rows preload
//       const uniqueEmployees = new Set([Number(employeeId)]);
//       const uniqueCityEmployeePairs = new Set();
//       // ─────────────────────────────────────────────────────────────────────

//       if (existing && Array.isArray(existing.entries)) {
//         for (const program of existing.entries) {
//           const dayId = new Date(program.working_date).getDate();

//           if (dateOfJoining && new Date(program.working_date) < dateOfJoining) {
//             continue;
//           }

//           // Parse values from API
//           let workingWithValue = "";
//           if (
//             program.working_with_employee_id !== null &&
//             program.working_with_employee_id !== undefined
//           ) {
//             workingWithValue = program.working_with_employee_id;
//           }

//           let secondaryWorkingWithValue = "";
//           if (
//             program.working_mode !== null &&
//             program.working_mode !== undefined
//           ) {
//             secondaryWorkingWithValue = program.working_mode;
//           }

//           let cityValue = "";
//           if (program.city_id !== null && program.city_id !== undefined) {
//             cityValue = program.city_id;
//           }

//           let routeValue = "";
//           if (program.route_id !== null && program.route_id !== undefined) {
//             routeValue = program.route_id;
//           }

//           // Store in form data
//           // initFormData[dayId] = {
//           //   city: cityValue,
//           //   route: routeValue,
//           //   workingWith: workingWithValue,
//           //   secondaryWorkingWith: secondaryWorkingWithValue,
//           //   remarks:
//           //     program.remarks === "Data Not Entered" ? "" : program.remarks,
//           //   programId: program.id,
//           // };
//           initFormData[dayId] = {
//           city: cityValue,
//           route: routeValue,
//           workingWith: workingWithValue,
//           secondaryWorkingWith: secondaryWorkingWithValue,
//           remarks:
//             program.remarks === "Data Not Entered"
//               ? ""
//               : program.remarks,
//           programId: program.id,
//         };

//           initOriginal[dayId] = { ...initFormData[dayId] };

//           // ── Collect unique employees & city-employee pairs ────────────────
//           if (workingWithValue) {
//             const emp = Number(workingWithValue);
//             if (Number.isFinite(emp) && emp !== 0) {
//               uniqueEmployees.add(emp);
//               if (cityValue) {
//                 uniqueCityEmployeePairs.add(`${emp}_${cityValue}`);
//               }
//             }
//           }

//           if (
//             secondaryWorkingWithValue &&
//             secondaryWorkingWithValue !== workingWithValue
//           ) {
//             const secEmp = Number(secondaryWorkingWithValue);
//             if (Number.isFinite(secEmp) && secEmp !== 0) {
//               uniqueEmployees.add(secEmp);
//               if (cityValue) {
//                 uniqueCityEmployeePairs.add(`${secEmp}_${cityValue}`);
//               }
//             }
//           }
//           // ─────────────────────────────────────────────────────────────────
//         }
//       }

//       // ── Single batched fetch — no duplicates ──────────────────────────────
//       const [assignedResults, routeResults, prevRouteResults] =
//         await Promise.all([
//           // Assigned cities — once per unique employee
//           Promise.all(
//             Array.from(uniqueEmployees).map(async (emp) => {
//               const cities = await fetchAssignedCities(emp);
//               return { emp, cities };
//             }),
//           ),
//           // Routes — once per unique employee+city pair
//           Promise.all(
//             Array.from(uniqueCityEmployeePairs).map(async (pair) => {
//               const [emp, city] = pair.split("_");
//               const fetchedRoutes = await fetchRoutesForCity(city, emp);
//               return { emp: Number(emp), cityId: city, fetchedRoutes };
//             }),
//           ),
//           // Previous routes — once per unique employee
//           Promise.all(
//             Array.from(uniqueEmployees).map(async (emp) => {
//               const fetchedRoutes = await fetchPreviousRoutesForEmployee(emp);
//               return { emp, fetchedRoutes };
//             }),
//           ),
//         ]);

//       if (!mountedRef.current) return;

//       // ── Store all results in state (cache for interactive handlers) ───────
//       const newAssignedCities = {};
//       for (const { emp, cities } of assignedResults) {
//         newAssignedCities[emp] = cities;
//       }
//       setAssignedCities((prev) => ({ ...prev, ...newAssignedCities }));

//       const newRoutes = {};
//       for (const { emp, cityId, fetchedRoutes } of routeResults) {
//         newRoutes[`${emp}_${cityId}`] = fetchedRoutes;
//       }
//       setRoutes((prev) => ({ ...prev, ...newRoutes }));

//       const newPrevRoutes = {};
//       for (const { emp, fetchedRoutes } of prevRouteResults) {
//         newPrevRoutes[emp] = fetchedRoutes;
//       }
//       setPreviousRoutesByEmployee((prev) => ({ ...prev, ...newPrevRoutes }));
//       // ─────────────────────────────────────────────────────────────────────

//       setFormData(initFormData);
//       setOriginalData(initOriginal);
//     } catch (err) {
//       if (mountedRef.current) {
//         console.error("fetchInitialData:", err);
//         setError(err.message || "Failed to load data");
//       }
//     } finally {
//       if (mountedRef.current) {
//         setIsLoading(false);
//       }
//     }
//   }, [
//     employeeId,
//     monthYearDisplay,
//     fetchWithAuth,
//     fetchAssignedCities,
//     fetchRoutesForCity,
//     fetchTeamMembers,
//     fetchPreviousRoutes,
//     isNewProgram,
//     dateOfJoining,
//     normalizeMonthYear,
//     fetchPreviousRoutesForEmployee,
//   ]);

//   // ── Stable ref pattern: runs only when employeeId changes, avoids
//   //    stale-closure issues without triggering re-run loops ──────────────────
//   const fetchInitialDataRef = useRef(fetchInitialData);
//   useEffect(() => {
//     fetchInitialDataRef.current = fetchInitialData;
//   }, [fetchInitialData]);

//   useEffect(() => {
//     if (!employeeId) return;
//     fetchInitialDataRef.current();
//   }, [employeeId]);
//   // ──────────────────────────────────────────────────────────────────────────

//   const handleChange = useCallback(
//     (dayId, field, value) => {
//       const dayData = daysArray.find((day) => day.id === dayId);
//       if (dayData && dayData.isBeforeDoj) {
//         return;
//       }

//       if (field === "workingWith") {
//         handleWorkingWithChange(dayId, value);
//       } else if (field === "secondaryWorkingWith") {
//         handleSecondaryWorkingWithChange(dayId, value);
//       } else if (field === "city") {
//         const workingWithEmployeeId = formData[dayId]?.workingWith;
//         handleCityChange(dayId, value, workingWithEmployeeId);
//       } else {
//         setFormData((prev) => ({
//           ...prev,
//           [dayId]: {
//             ...prev[dayId],
//             [field]: value,
//           },
//         }));
//       }
//     },
//     [
//       daysArray,
//       formData,
//       handleWorkingWithChange,
//       handleCityChange,
//       handleSecondaryWorkingWithChange,
//     ],
//   );

//   const handleSubmit = useCallback(
//     async (skipRefetch = false) => {
//       if (!currentUser?.username || !mountedRef.current) {
//         toast.warning("User information not available");
//         return;
//       }

//       setIsSubmitting(true);
//       try {
//         const allEntries = daysArray
//           .filter((day) => !day.isBeforeDoj)
//           .map((day) => {
//             const dayData = formData[day.id] || {};
//             const routeId = dayData.route
//               ? Number.parseInt(dayData.route)
//               : null;
//             const workingWithId =
//               dayData.workingWith !== undefined &&
//               dayData.workingWith !== null &&
//               dayData.workingWith !== ""
//                 ? Number.parseInt(dayData.workingWith)
//                 : null;

//             let cityId = dayData.city ? Number.parseInt(dayData.city) : null;
//             if (!cityId && routeId) {
//               const selectedRoute = previousRoutes.find(
//                 (r) => r.id === routeId,
//               );
//               if (selectedRoute) {
//                 cityId = selectedRoute.city_id;
//               }
//             }
//             if (!cityId) {
//               cityId = 0;
//             }

//             const entry = {
//               working_date: formatDateForAPI(day.dateObj),
//               remarks: dayData.remarks || "",
//               route_id: routeId,
//               city_id: cityId,
//               remarks: dayData.remarks || "",
//               working_with_employee_id: workingWithId,
//               working_mode:
//                 dayData.secondaryWorkingWith !== undefined &&
//                 dayData.secondaryWorkingWith !== null &&
//                 dayData.secondaryWorkingWith !== ""
//                   ? Number.parseInt(dayData.secondaryWorkingWith)
//                   : workingWithId,
//               is_sunday: day.day === "Sunday",
//             };

//             if (dayData.programId && !isNewProgram) {
//               entry.tour_program_id = Number.parseInt(dayData.programId);
//             }
//             return entry;
//           });

//         const normalizedMonthYear = normalizeMonthYear(monthYearDisplay);

//         const payload = {
//           employee_id: Number.parseInt(employeeId),
//           month_year: normalizedMonthYear,
//           tour_data: allEntries,
//             remarks: "Monthly plan approved",

//         };

//         const method = isNewProgram ? "POST" : "PUT";
//         const response = await fetchWithAuth(
//           `${BASE_URL}/api/tour-programs/tour-monthly`,
//           {
//             method: method,
//             headers: {
//               "X-User-Name": currentUser.username,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(payload),
//           },
//         );

//         if (!mountedRef.current) return;

//         if (response && response.message) {
//           toast.success(response.message);
//         } else {
//           toast.success(
//             isNewProgram
//               ? "Tour program created successfully."
//               : "Tour program updated successfully.",
//           );
//         }

//         if (!skipRefetch) {
//           await fetchInitialData();
//         }
//       } catch (err) {
//         if (mountedRef.current) {
//           console.error("handleSubmit:", err);
//           toast.error(err.message || "Failed to save tour program");
//         }
//       } finally {
//         if (mountedRef.current) {
//           setIsSubmitting(false);
//         }
//       }
//     },
//     [
//       currentUser,
//       daysArray,
//       formData,
//       previousRoutes,
//       employeeId,
//       monthYearDisplay,
//       isNewProgram,
//       formatDateForAPI,
//       fetchWithAuth,
//       fetchInitialData,
//       normalizeMonthYear,
//     ],
//   );

//   const handleApprove = useCallback(async () => {
//     if (!currentUser?.username || !mountedRef.current) {
//       toast.warning("User information not available");
//       return;
//     }

//     if (approvalStatus === "approved") {
//       toast.info("Month is already approved");
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       await handleSubmit(true);

//       const monthYear = new Intl.DateTimeFormat("en", {
//         month: "short",
//         year: "numeric",
//       }).format(new Date(`${selectedYear}-${selectedMonth}-01`));
//       const normalizedMonthYear = normalizeMonthYear(monthYear);

//       const payload = {
//         monthYear: normalizedMonthYear,
//         status: "approved",
//         remarks: "Monthly plan approved",
//       };

//       console.log("Sending approval request with payload:", payload);

//       const response = await fetchWithAuth(
//         `${BASE_URL}/api/tour-programs/employee/${employeeId}/approve`,
//         {
//           method: "PUT",
//           headers: {
//             "X-User-Name": currentUser.username,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         },
//       );

//       if (!mountedRef.current) return;
//       if (response?.message) {
//         toast.success(response.message);
//       } else if (response?.status) {
//         toast.success(`Monthly plan ${response.status}`);
//       } else {
//         toast.success("Monthly plan approved successfully");
//       }

//       setApprovalStatus("approved");
//       await fetchInitialData();
//     } catch (err) {
//       if (mountedRef.current) {
//         console.error("handleApprove error:", err);
//         toast.error(err.message || "Failed to approve monthly plan");
//       }
//     } finally {
//       if (mountedRef.current) {
//         setIsSubmitting(false);
//       }
//     }
//   }, [
//     currentUser,
//     selectedYear,
//     selectedMonth,
//     employeeId,
//     fetchWithAuth,
//     fetchInitialData,
//     normalizeMonthYear,
//     handleSubmit,
//     approvalStatus,
//   ]);

//   const handleReturn = useCallback(() => {
//     const preservedState = location.state?.preservedState || {};
//     navigate("/tour-program", {
//       state: { preservedState },
//       replace: true,
//     });
//   }, [location.state?.preservedState, navigate]);

//   return (
//     <div className="">
//       {isLoading && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25">
//           <Loader onCancel={() => setIsLoading(false)} />
//         </div>
//       )}
//       <div
//         className={`main-container ${
//           isLoading || isSubmitting ? "blur-sm pointer-events-none" : ""
//         }`}
//       >
//         <div className="tourpage-container">
//           <div className="flex justify-center mb-5">
//             <h2 className="whitespace-nowrap">
//               {employeeData.name || "Employee"} (
//               {employeeData.designation || "Designation"} |{" "}
//               {employeeData.headquarter || "HQ"} |{" "}
//               {employeeData.division || "Division"} |{" "}
//               {employeeData.state || "State"}) Tour Program – {monthYearDisplay}
//               {dateOfJoining ? (
//                 <span
//                   style={{
//                     color: "red",
//                     fontSize: "0.8em",
//                     marginLeft: "10px",
//                   }}
//                 >
//                   (Date of Joining: {dateOfJoining.toLocaleDateString("en-GB")})
//                 </span>
//               ) : (
//                 <span
//                   style={{
//                     color: "orange",
//                     fontSize: "0.8em",
//                     marginLeft: "10px",
//                   }}
//                 >
//                   (Date of Joining: Not Available)
//                 </span>
//               )}
//             </h2>
//           </div>

//           <table className="tourpage-table">
//             <thead className="bg-blue-600 text-white sticky top-0 z-10 shadow-sm">
//               <tr>
//                 <th>S.No</th>
//                 <th>Working Date &amp; Day</th>
//                 {isTsmOrAbove ? (
//                   <>
//                     <th>Working With</th>
//                     <th>Route Owner</th>
//                     <th>City</th>
//                     <th>Routes</th>
//                     <th>Remarks</th>
//                   </>
//                 ) : (
//                   <>
//                     <th>Working With</th>
//                     <th>Routes</th>
//                     <th>Remarks</th>
//                   </>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {daysArray.map((day) => {
//                 const formDay = formData[day.id] || {};
//                 const isSunday = day.day === "Sunday";
//                 const isBeforeDoj = day.isBeforeDoj;
//                 const isIndividualSelected =
//                   Number(formDay.workingWith) === Number(employeeId);

//                 // For smaller roles (ASE, MR), always use their own ID
//                 const effectiveEmpForPrevRoutes = !isTsmOrAbove
//                   ? Number(employeeId)
//                   : (() => {
//                       if (
//                         Number(formDay.workingWith) === Number(employeeId) &&
//                         formDay.secondaryWorkingWith
//                       ) {
//                         return Number(formDay.secondaryWorkingWith);
//                       }
//                       if (formDay.workingWith)
//                         return Number(formDay.workingWith);
//                       return Number(employeeId);
//                     })();

//                 const sundayRoutes =
//                   previousRoutesByEmployee[effectiveEmpForPrevRoutes] ||
//                   previousRoutes ||
//                   [];

//                 const effectiveEmpForCity = !isTsmOrAbove
//                   ? Number(employeeId)
//                   : (() => {
//                       if (
//                         Number(formDay.workingWith) === Number(employeeId) &&
//                         formDay.secondaryWorkingWith
//                       ) {
//                         return Number(formDay.secondaryWorkingWith);
//                       }
//                       if (formDay.workingWith && formDay.workingWith !== "")
//                         return Number(formDay.workingWith);
//                       return Number(employeeId);
//                     })();

//                 const cityKey = formDay.city
//                   ? `${effectiveEmpForCity}_${String(formDay.city)}`
//                   : null;
//                 const routesForCity = cityKey ? routes[cityKey] || [] : [];

//                 const citiesForEmployee =
//                   formDay.workingWith && formDay.workingWith !== 0
//                     ? assignedCities[effectiveEmpForCity] || []
//                     : formDay.workingWith === 0
//                       ? assignedCities[0] || []
//                       : [];

//                 const rowClass = isSunday
//                   ? "tourpage-sunday-row"
//                   : isBeforeDoj
//                     ? "tourpage-disabled-row"
//                     : "";

//                 return (
//                   <tr key={day.id} className={rowClass}>
//                     <td>{day.id}</td>
//                     <td>
//                       {day.dateObj.toLocaleDateString("en-GB", {
//                         day: "2-digit",
//                         month: "long",
//                         year: "numeric",
//                       })}{" "}
//                       ({day.day})
//                       {isBeforeDoj && (
//                         <span style={{ color: "red", marginLeft: "5px" }}>
//                           (Before DOJ)
//                         </span>
//                       )}
//                     </td>

//                     {isTsmOrAbove ? (
//                       <>
//                         <td>
//                           <select
//                             className="tourpage-dropdown"
//                             value={formDay.workingWith ?? ""}
//                             onChange={(e) =>
//                               handleChange(
//                                 day.id,
//                                 "workingWith",
//                                 e.target.value,
//                               )
//                             }
//                             disabled={isBeforeDoj}
//                           >
//                             <option value="">Select</option>
//                             {teamMembers.map((member) => {
//                               const label =
//                                 member.employee_id === 0
//                                   ? "Meeting"
//                                   : member.employee_id === employeeId
//                                     ? `individual`
//                                     : `${member.first_name} ${member.last_name} (${member.designation} | ${member.city_name} | ${member.state_name})`;
//                               return (
//                                 <option
//                                   key={member.employee_id}
//                                   value={member.employee_id}
//                                 >
//                                   {label}
//                                 </option>
//                               );
//                             })}
//                           </select>
//                         </td>
//                         <td>
//                           <select
//                             className="tourpage-dropdown"
//                             value={formDay.secondaryWorkingWith ?? ""}
//                             onChange={(e) =>
//                               handleChange(
//                                 day.id,
//                                 "secondaryWorkingWith",
//                                 e.target.value,
//                               )
//                             }
//                             disabled={isBeforeDoj || !isIndividualSelected}
//                           >
//                             <option value="">Select</option>
//                             {teamMembers.map((member) => {
//                               const label =
//                                 member.employee_id === 0
//                                   ? "Meeting"
//                                   : member.employee_id === employeeId
//                                     ? `individual`
//                                     : `${member.first_name} ${member.last_name} (${member.designation} | ${member.city_name} | ${member.state_name})`;
//                               return (
//                                 <option
//                                   key={member.employee_id}
//                                   value={member.employee_id}
//                                 >
//                                   {label}
//                                 </option>
//                               );
//                             })}
//                           </select>
//                         </td>
//                         <td>
//                           <select
//                             className="tourpage-dropdown"
//                             value={formDay.city || ""}
//                             onChange={(e) =>
//                               handleChange(day.id, "city", e.target.value)
//                             }
//                             disabled={
//                               isBeforeDoj ||
//                               (!formDay.workingWith &&
//                                 formDay.workingWith !== 0 &&
//                                 !isSunday)
//                             }
//                           >
//                             <option value="">Select City</option>
//                             {citiesForEmployee.map((city) => (
//                               <option key={city.city_id} value={city.city_id}>
//                                 {city.city_name}
//                               </option>
//                             ))}
//                           </select>
//                         </td>
//                         <td>
//                           <select
//                             className="tourpage-dropdown"
//                             value={formDay.route || ""}
//                             onChange={(e) =>
//                               handleChange(day.id, "route", e.target.value)
//                             }
//                             disabled={
//                               isBeforeDoj ||
//                               (!formDay.city && !isSunday) ||
//                               (!formDay.workingWith &&
//                                 formDay.workingWith !== 0 &&
//                                 !isSunday)
//                             }
//                           >
//                             <option value="">Select Route</option>
//                             {(isSunday ? sundayRoutes : routesForCity).map(
//                               (route) => (
//                                 <option key={route.id} value={route.id}>
//                                   {route.name || route.route_name}
//                                 </option>
//                               ),
//                             )}
//                           </select>
//                         </td>
//                       </>
//                     ) : (
//                       <>
//                         <td>
//                           <select
//                             className="tourpage-dropdown"
//                             value={formDay.workingWith ?? ""}
//                             onChange={(e) =>
//                               handleChange(
//                                 day.id,
//                                 "workingWith",
//                                 e.target.value,
//                               )
//                             }
//                             disabled={isBeforeDoj}
//                           >
//                             <option value="">Select</option>
//                             {teamMembers.map((member) => {
//                               const label =
//                                 member.employee_id === 0
//                                   ? "Meeting"
//                                   : member.employee_id === employeeId
//                                     ? `individual`
//                                     : `${member.first_name} ${member.last_name} (${member.designation} | ${member.city_name} | ${member.state_name})`;
//                               return (
//                                 <option
//                                   key={member.employee_id}
//                                   value={member.employee_id}
//                                 >
//                                   {label}
//                                 </option>
//                               );
//                             })}
//                           </select>
//                         </td>
//                         <td>
//                           <select
//                             className="tourpage-dropdown"
//                             value={formDay.route || ""}
//                             onChange={(e) =>
//                               handleChange(day.id, "route", e.target.value)
//                             }
//                             disabled={isBeforeDoj}
//                           >
//                             <option value="">Select Route</option>
//                             {(sundayRoutes || []).map((route) => (
//                               <option key={route.id} value={route.id}>
//                                 {route.name || route.route_name}
//                               </option>
//                             ))}
//                           </select>
//                         </td>
//                         <RemarksCell
//   value={formDay.remarks || ""}
//   onChange={(val) =>
//     handleChange(day.id, "remarks", val)
//   }
//   disabled={isBeforeDoj}
// />
//                       </>

//                     )}
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>

//           <div
//             className="tourpage-buttons"
//             style={{ display: "flex", gap: 8, alignItems: "center" }}
//           >
//             <CustomButton
//               variant="save"
//               onClick={() => handleSubmit()}
//               disabled={isSubmitting || !currentUser}
//             >
//               {isSubmitting ? (
//                 <>
//                   <span
//                     className="spinner-border spinner-border-sm"
//                     role="status"
//                     aria-hidden="true"
//                   ></span>
//                   Submitting...
//                 </>
//               ) : (
//                 "Submit"
//               )}
//             </CustomButton>

//             <CustomButton variant="cancel" onClick={handleReturn}>
//               Return
//             </CustomButton>

//             {approvalStatus !== "approved" && (
//               <CustomButton
//                 className="whitespace-nowrap"
//                 variant="save"
//                 onClick={handleApprove}
//                 disabled={isSubmitting || !currentUser || isNewProgram}
//               >
//                 Approve
//               </CustomButton>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TourProgramModified;

import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../css/AddTourProgram.css";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import Loader from "../dist/Loader";
import CustomButton from "./CustomButton";

const ROLE_HIERARCHY = [
  "superadmin",
  "admin",
  "coordinator",
  "distributor",
  "nsm",
  "zsm",
  "rsm",
  "asm",
  "tsm",
  "ase",
  "mr",
];

const normalizeRole = (role = "") => {
  if (!role) return "";
  const roleStr = role.toString().trim().toLowerCase();
  const roleMap = {
    "team sales manager": "tsm",
    tsm: "tsm",
    "area sales executive": "ase",
    ase: "ase",
    "medical representative": "mr",
    mr: "mr",
    me: "mr",
    "medical executive": "mr",
    "regional sales manager": "rsm",
    rsm: "rsm",
    "area sales manager": "asm",
    asm: "asm",
    "zone sales manager": "zsm",
    zsm: "zsm",
    "national sales manager": "nsm",
    nsm: "nsm",
    coordinator: "coordinator",
    admin: "admin",
    superadmin: "superadmin",
    distributor: "distributor",
  };
  return roleMap[roleStr] || roleStr;
};
const RemarksCell = ({ value, onChange, disabled }) => (
  <td
    style={{
      minWidth: 220,
      padding: "6px 8px",
      verticalAlign: "middle",
    }}
  >
    <div className="tourpage-remarks-wrapper">
      {/* Free-text input — employee types any remark */}
      <input
        type="text"
        className="border rounded px-2 py-1 w-full"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder="Type remarks..."
      />
    </div>
  </td>
);

const TourProgramModified = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const abortControllerRef = useRef(null);
  const mountedRef = useRef(true);

  const [currentUser, setCurrentUser] = useState(null);
  const [originalData, setOriginalData] = useState({});
  const [formData, setFormData] = useState({});
  const [routes, setRoutes] = useState({});
  const [teamMembers, setTeamMembers] = useState([]);
  const [previousRoutes, setPreviousRoutes] = useState([]);
  const [previousRoutesByEmployee, setPreviousRoutesByEmployee] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [assignedCities, setAssignedCities] = useState({});
  const [approvalStatus, setApprovalStatus] = useState("pending");
  const [tourExists, setTourExists] = useState(false);

  const employeeData = useMemo(() => {
    const fromState = location.state?.employeeData;
    const fromStorage = localStorage.getItem("employeeData");

    let data = null;
    if (fromState) {
      data = fromState;
    } else if (fromStorage) {
      try {
        data = JSON.parse(fromStorage);
      } catch (e) {
        console.error("Failed to parse employeeData from localStorage:", e);
        data = {};
      }
    } else {
      data = {};
    }

    const mappedData = {
      id: data.emp_id || data.id || data.employee_id,
      name: data.emp_name || data.name || data.employee_name,
      designation: data.desi || data.designation || data.role_name,
      role: data.role || data.desi || data.designation,
      headquarter: data.hq || data.headquarter,
      division: data.div || data.division,
      state: data.state,
      city: data.city,
      final_joining_date:
        data.doj || data.final_joining_date || data.date_of_joining,
      selectedMonth: data.selectedMonth,
      selectedYear: data.selectedYear,
    };

    if (fromState) {
      localStorage.setItem("employeeData", JSON.stringify(mappedData));
    }

    return mappedData;
  }, [location.state?.employeeData]);

  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const determineRole = () => {
      if (employeeData?.role) {
        const normalized = normalizeRole(employeeData.role);
        console.log(
          "Using role from employeeData.role:",
          employeeData.role,
          "->",
          normalized,
        );
        if (normalized && ROLE_HIERARCHY.includes(normalized)) {
          return normalized;
        }
      }
      if (location.state?.role) {
        const normalized = normalizeRole(location.state.role);
        console.log(
          "Using role from location.state.role:",
          location.state.role,
          "->",
          normalized,
        );
        if (normalized && ROLE_HIERARCHY.includes(normalized)) {
          return normalized;
        }
      }
      const storedRole = localStorage.getItem("role");
      if (storedRole) {
        const normalized = normalizeRole(storedRole);
        console.log(
          "Using role from localStorage:",
          storedRole,
          "->",
          normalized,
        );
        if (normalized && ROLE_HIERARCHY.includes(normalized)) {
          return normalized;
        }
      }
      if (employeeData?.designation) {
        const normalized = normalizeRole(employeeData.designation);
        console.log(
          "Using role from designation:",
          employeeData.designation,
          "->",
          normalized,
        );
        if (normalized && ROLE_HIERARCHY.includes(normalized)) {
          return normalized;
        }
      }
      console.log("No valid role found");
      return "";
    };

    const role = determineRole();
    setUserRole(role);
  }, [employeeData, location.state?.role]);

  const isNewProgram = useMemo(() => {
    return location.state?.isNewProgram || false;
  }, [location.state?.isNewProgram]);

  const isTsmOrAbove = useMemo(() => {
    if (!userRole) {
      console.log("No userRole found, defaulting to false");
      return false;
    }
    const tsmIndex = ROLE_HIERARCHY.indexOf("tsm");
    const currentIndex = ROLE_HIERARCHY.indexOf(userRole);
    const isTsmOrAboveResult = currentIndex !== -1 && currentIndex <= tsmIndex;
    return isTsmOrAboveResult;
  }, [userRole]);

  const {
    employeeId,
    selectedMonth,
    selectedYear,
    dateOfJoining,
    monthYearDisplay,
  } = useMemo(() => {
    const empId = employeeData?.id;
    const selMonth = employeeData?.selectedMonth || new Date().getMonth() + 1;
    const selYear = employeeData?.selectedYear || new Date().getFullYear();

    const getDateOfJoining = () => {
      const dojDate =
        employeeData?.final_joining_date ||
        employeeData?.doj ||
        employeeData?.date_of_joining;

      if (!dojDate) return null;

      try {
        if (typeof dojDate === "string") {
          const s = dojDate.trim();
          const dmyDash = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
          const dmySlash = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
          let m = s.match(dmyDash) || s.match(dmySlash);
          if (m) {
            const day = Number(m[1]);
            const month = Number(m[2]);
            const year = Number(m[3]);
            const date = new Date(year, month - 1, day);
            if (!isNaN(date.getTime())) return date;
            return null;
          }
          const iso = new Date(s);
          if (!isNaN(iso.getTime())) return iso;
          return null;
        }
        if (dojDate instanceof Date && !isNaN(dojDate.getTime()))
          return dojDate;
        if (typeof dojDate === "number") {
          const date = new Date(dojDate);
          return isNaN(date.getTime()) ? null : date;
        }
        return null;
      } catch (error) {
        console.error("Error parsing date of joining:", error, dojDate);
        return null;
      }
    };

    const doj = getDateOfJoining();

    const monthYear = new Intl.DateTimeFormat("en", {
      month: "short",
      year: "numeric",
    }).format(new Date(selYear, selMonth - 1));

    return {
      employeeId: empId,
      selectedMonth: selMonth,
      selectedYear: selYear,
      dateOfJoining: doj,
      monthYearDisplay: monthYear,
    };
  }, [employeeData]);

  const normalizeMonthYear = useCallback((my) => {
    if (!my) return my;
    return my
      .replace(/\bSept\.?\b/gi, "Sep")
      .replace(/\s+/g, " ")
      .trim();
  }, []);

  const daysArray = useMemo(() => {
    const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, index) => {
      const date = new Date(selectedYear, selectedMonth - 1, index + 1);

      let isBeforeDoj = false;
      if (dateOfJoining) {
        const compareDate = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
        );
        const compareDoj = new Date(
          dateOfJoining.getFullYear(),
          dateOfJoining.getMonth(),
          dateOfJoining.getDate(),
        );
        isBeforeDoj = compareDate < compareDoj;
      }

      return {
        id: index + 1,
        day: date.toLocaleDateString("en-US", { weekday: "long" }),
        dateObj: date,
        date: date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
        isBeforeDoj,
      };
    });
  }, [selectedMonth, selectedYear, dateOfJoining]);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const formatDateForAPI = useCallback((date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }, []);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("loggedInUser");
      if (stored) {
        setCurrentUser(JSON.parse(stored));
      } else {
        setCurrentUser({ username: "default_user" });
      }
    } catch (err) {
      console.error("Error reading loggedInUser:", err);
      setCurrentUser({ username: "default_user" });
    }
  }, []);

  useEffect(() => {
    if (userRole) {
      localStorage.setItem("userRole", userRole);
      console.log("Stored userRole in localStorage:", userRole);
    }
  }, [userRole]);

  const fetchWithAuth = useCallback(async (url, options = {}) => {
    if (!mountedRef.current) return null;

    const controller = new AbortController();
    abortControllerRef.current = controller;

    const headers = {
      ...getAuthHeaders(),
      "Content-Type": "application/json",
      ...(options.headers || {}),
    };

    try {
      const resp = await fetch(url, {
        ...options,
        headers,
        signal: controller.signal,
      });

      if (!resp.ok) {
        const errData = await resp.json().catch(() => null);
        const errMsg =
          (errData && (errData.detail || errData.message)) ||
          (errData ? JSON.stringify(errData) : `HTTP error ${resp.status}`);
        throw new Error(errMsg);
      }
      return await resp.json();
    } catch (err) {
      if (err.name === "AbortError") {
        return null;
      }
      console.error("fetchWithAuth:", err);
      throw err;
    }
  }, []);

  const fetchAssignedCities = useCallback(
    async (empId) => {
      if (!empId || !mountedRef.current) return [];
      try {
        const data = await fetchWithAuth(
          `${BASE_URL}/api/assigned-cities/${empId}`,
        );
        return Array.isArray(data) ? data : [];
      } catch (err) {
        if (mountedRef.current) {
          console.error("fetchAssignedCities:", err);
        }
        return [];
      }
    },
    [fetchWithAuth],
  );

  const fetchRoutesForCity = useCallback(
    async (cityId, empId) => {
      const id = empId || employeeId;
      if (!cityId || !id || !mountedRef.current) return [];
      try {
        const data = await fetchWithAuth(
          `${BASE_URL}/api/routes/${id}/?city_id=${cityId}`,
        );
        return Array.isArray(data) ? data : [];
      } catch (err) {
        if (mountedRef.current) {
          console.error("fetchRoutesForCity:", err);
        }
        return [];
      }
    },
    [employeeId, fetchWithAuth],
  );

  const fetchPreviousRoutes = useCallback(async () => {
    if (!employeeId || !mountedRef.current) return [];
    try {
      const data = await fetchWithAuth(
        `${BASE_URL}/api/previous_routes/employee/${employeeId}`,
      );
      return Array.isArray(data) ? data : [];
    } catch (err) {
      if (mountedRef.current) {
        console.error("fetchPreviousRoutes:", err);
      }
      return [];
    }
  }, [employeeId, fetchWithAuth]);

  const fetchPreviousRoutesForEmployee = useCallback(
    async (empId) => {
      if (!empId || !mountedRef.current) return [];
      try {
        const data = await fetchWithAuth(
          `${BASE_URL}/api/previous_routes/employee/${empId}`,
        );
        const arr = Array.isArray(data) ? data : [];
        if (mountedRef.current) {
          setPreviousRoutesByEmployee((prev) => ({
            ...prev,
            [Number(empId)]: arr,
          }));
        }
        return arr;
      } catch (err) {
        if (mountedRef.current) {
          console.error("fetchPreviousRoutesForEmployee:", err);
        }
        return [];
      }
    },
    [fetchWithAuth],
  );

  const fetchTeamMembers = useCallback(async () => {
    if (!employeeId || !mountedRef.current) return [];
    try {
      const params = new URLSearchParams();
      const designation = employeeData?.designation?.toUpperCase() || "";
      if (designation) params.set("designation", designation);
      params.set("employee_id", String(employeeId));

      const data = await fetchWithAuth(
        `${BASE_URL}/api/employees-by-designation?${params.toString()}`,
      );

      const meetingOption = {
        employee_id: 0,
        employee_name: "Meeting",
        first_name: "",
        last_name: "",
        designation: "",
        city_name: "",
        state_name: "",
      };

      const individualOption = {
        employee_id: Number(employeeId),
        employee_name: "individual",
        first_name: "individual",
        last_name: "individual",
        designation: employeeData?.designation || "",
        city_name: employeeData?.city || "",
        state_name: employeeData?.state || "",
      };

      const apiEmployees = Array.isArray(data) ? data : [];

      const map = new Map();
      map.set(0, meetingOption);
      map.set(Number(individualOption.employee_id), individualOption);

      for (const emp of apiEmployees) {
        const id = Number(emp.employee_id);
        if (!Number.isFinite(id)) continue;
        if (!map.has(id)) {
          map.set(id, {
            employee_id: id,
            employee_name:
              emp.employee_name ||
              `${emp.first_name || ""} ${emp.last_name || ""}`.trim(),
            first_name: emp.first_name || "",
            last_name: emp.last_name || "",
            designation: emp.designation || "",
            city_name: emp.city_name || emp.city || "",
            state_name: emp.state_name || emp.state || "",
          });
        }
      }

      return Array.from(map.values());
    } catch (err) {
      if (mountedRef.current) {
        console.error("fetchTeamMembers:", err);
      }
      return [];
    }
  }, [employeeId, employeeData, fetchWithAuth]);

  const debounceTimeoutRef = useRef({});

  const handleWorkingWithChange = useCallback(
    async (dayId, value) => {
      if (!mountedRef.current) return;
      const newWorkingWith = value === "" ? "" : Number.parseInt(value, 10);

      if (debounceTimeoutRef.current[dayId]) {
        clearTimeout(debounceTimeoutRef.current[dayId]);
      }

      const autoSecondary =
        newWorkingWith &&
          !Number.isNaN(newWorkingWith) &&
          newWorkingWith !== 0 &&
          newWorkingWith !== employeeId
          ? newWorkingWith
          : "";

      setFormData((prev) => ({
        ...prev,
        [dayId]: {
          ...prev[dayId],
          workingWith: newWorkingWith,
          city:
            prev[dayId]?.workingWith !== newWorkingWith
              ? ""
              : prev[dayId]?.city || "",
          route:
            prev[dayId]?.workingWith !== newWorkingWith
              ? ""
              : prev[dayId]?.route || "",
          secondaryWorkingWith: autoSecondary,
        },
      }));

      if (autoSecondary) {
        // Only fetch if not already cached
        if (!previousRoutesByEmployee[Number(autoSecondary)]) {
          fetchPreviousRoutesForEmployee(autoSecondary).catch(() => { });
        }
      }

      if (!isTsmOrAbove) {
        debounceTimeoutRef.current[dayId] = setTimeout(async () => {
          if (!mountedRef.current) return;
          try {
            // Guard: skip if already cached
            if (assignedCities[Number(employeeId)]?.length > 0) {
              return;
            }
            const cities = await fetchAssignedCities(employeeId);
            if (mountedRef.current) {
              setAssignedCities((prev) => ({
                ...prev,
                [Number(employeeId)]: cities,
              }));
            }
          } catch (err) {
            if (mountedRef.current) {
              console.error("handleWorkingWithChange:", err);
            }
          }
        }, 300);
      } else {
        if (
          newWorkingWith &&
          !Number.isNaN(newWorkingWith) &&
          newWorkingWith !== 0
        ) {
          debounceTimeoutRef.current[dayId] = setTimeout(async () => {
            if (!mountedRef.current) return;
            try {
              // Guard: skip if already cached
              if (assignedCities[Number(newWorkingWith)]?.length > 0) {
                return;
              }
              const cities = await fetchAssignedCities(newWorkingWith);
              if (mountedRef.current) {
                setAssignedCities((prev) => ({
                  ...prev,
                  [Number(newWorkingWith)]: cities,
                }));
              }
            } catch (err) {
              if (mountedRef.current) {
                console.error("handleWorkingWithChange:", err);
              }
            }
          }, 300);
        } else if (newWorkingWith === 0) {
          debounceTimeoutRef.current[dayId] = setTimeout(async () => {
            if (!mountedRef.current) return;
            try {
              // Guard: skip if already cached
              if (assignedCities[0]?.length > 0) {
                return;
              }
              const cities = await fetchAssignedCities(employeeId);
              if (mountedRef.current) {
                setAssignedCities((prev) => ({
                  ...prev,
                  [0]: cities,
                }));
              }
            } catch (err) {
              if (mountedRef.current) {
                console.error("handleWorkingWithChange for Meeting:", err);
              }
            }
          }, 300);
        }
      }
    },
    [
      fetchAssignedCities,
      employeeId,
      fetchPreviousRoutesForEmployee,
      isTsmOrAbove,
      assignedCities,
      previousRoutesByEmployee,
    ],
  );

  const handleSecondaryWorkingWithChange = useCallback(
    async (dayId, value) => {
      if (!mountedRef.current) return;
      const newSecondary = value === "" ? "" : Number.parseInt(value, 10);

      setFormData((prev) => ({
        ...prev,
        [dayId]: {
          ...prev[dayId],
          secondaryWorkingWith: newSecondary,
        },
      }));

      if (newSecondary && newSecondary !== 0) {
        // Only fetch if not already cached
        if (!previousRoutesByEmployee[Number(newSecondary)]) {
          fetchPreviousRoutesForEmployee(newSecondary).catch(() => { });
        }
      }

      if (!isTsmOrAbove) {
        if (newSecondary && newSecondary !== 0) {
          try {
            // Guard: skip if already cached
            if (!assignedCities[Number(employeeId)]?.length) {
              const cities = await fetchAssignedCities(employeeId);
              if (mountedRef.current) {
                setAssignedCities((prev) => ({
                  ...prev,
                  [Number(employeeId)]: cities,
                }));
              }
            }
          } catch (err) {
            if (mountedRef.current)
              console.error(
                "handleSecondaryWorkingWithChange - fetchAssignedCities:",
                err,
              );
          }

          const selectedCity = formData[dayId]?.city;
          if (selectedCity) {
            try {
              const routeKey = `${Number(employeeId)}_${String(selectedCity)}`;
              // Guard: skip if already cached
              if (!routes[routeKey]?.length) {
                const cityRoutes = await fetchRoutesForCity(
                  selectedCity,
                  employeeId,
                );
                if (mountedRef.current) {
                  setRoutes((prev) => ({
                    ...prev,
                    [routeKey]: cityRoutes,
                  }));
                }
              }
            } catch (err) {
              if (mountedRef.current)
                console.error(
                  "handleSecondaryWorkingWithChange - fetchRoutesForCity:",
                  err,
                );
            }
          }
        }
      } else {
        if (newSecondary && newSecondary !== 0) {
          try {
            // Guard: skip if already cached
            if (!assignedCities[Number(newSecondary)]?.length) {
              const cities = await fetchAssignedCities(newSecondary);
              if (mountedRef.current) {
                setAssignedCities((prev) => ({
                  ...prev,
                  [Number(newSecondary)]: cities,
                }));
              }
            }
          } catch (err) {
            if (mountedRef.current)
              console.error(
                "handleSecondaryWorkingWithChange - fetchAssignedCities:",
                err,
              );
          }

          const selectedCity = formData[dayId]?.city;
          if (selectedCity) {
            try {
              const routeKey = `${Number(newSecondary)}_${String(selectedCity)}`;
              // Guard: skip if already cached
              if (!routes[routeKey]?.length) {
                const cityRoutes = await fetchRoutesForCity(
                  selectedCity,
                  newSecondary,
                );
                if (mountedRef.current) {
                  setRoutes((prev) => ({
                    ...prev,
                    [routeKey]: cityRoutes,
                  }));
                }
              }
            } catch (err) {
              if (mountedRef.current)
                console.error(
                  "handleSecondaryWorkingWithChange - fetchRoutesForCity:",
                  err,
                );
            }
          }
        }
      }
    },
    [
      fetchPreviousRoutesForEmployee,
      fetchAssignedCities,
      fetchRoutesForCity,
      formData,
      employeeId,
      isTsmOrAbove,
      assignedCities,
      routes,
      previousRoutesByEmployee,
    ],
  );

  const handleCityChange = useCallback(
    async (dayId, cityId, empId) => {
      if (!mountedRef.current) return;

      if (!cityId) {
        setFormData((prev) => ({
          ...prev,
          [dayId]: {
            ...prev[dayId],
            city: "",
            route: "",
          },
        }));
        return;
      }

      if (debounceTimeoutRef.current[`city_${dayId}`]) {
        clearTimeout(debounceTimeoutRef.current[`city_${dayId}`]);
      }

      setFormData((prev) => ({
        ...prev,
        [dayId]: {
          ...prev[dayId],
          city: cityId,
          route: prev[dayId]?.city !== cityId ? "" : prev[dayId]?.route || "",
        },
      }));

      if (!isTsmOrAbove) {
        const routeKey = `${Number(employeeId)}_${String(cityId)}`;

        debounceTimeoutRef.current[`city_${dayId}`] = setTimeout(async () => {
          if (!mountedRef.current) return;
          try {
            // Guard: skip if already cached
            if (routes[routeKey]?.length > 0) {
              return;
            }
            const cityRoutes = await fetchRoutesForCity(cityId, employeeId);
            if (mountedRef.current) {
              setRoutes((prev) => ({
                ...prev,
                [routeKey]: cityRoutes,
              }));
            }
          } catch (err) {
            if (mountedRef.current) {
              console.error("handleCityChange:", err);
              toast.error("Failed to load routes for selected city");
            }
          }
        }, 300);
      } else {
        const primary = formData[dayId]?.workingWith;
        const secondary = formData[dayId]?.secondaryWorkingWith;
        let targetEmployee = empId || primary || employeeId;
        if (Number(primary) === Number(employeeId) && secondary) {
          targetEmployee = secondary;
        }

        const routeKey = `${Number(targetEmployee)}_${String(cityId)}`;

        debounceTimeoutRef.current[`city_${dayId}`] = setTimeout(async () => {
          if (!mountedRef.current) return;
          try {
            // Guard: skip if already cached
            if (routes[routeKey]?.length > 0) {
              return;
            }
            const cityRoutes = await fetchRoutesForCity(cityId, targetEmployee);
            if (mountedRef.current) {
              setRoutes((prev) => ({
                ...prev,
                [routeKey]: cityRoutes,
              }));
            }
          } catch (err) {
            if (mountedRef.current) {
              console.error("handleCityChange:", err);
              toast.error("Failed to load routes for selected city");
            }
          }
        }, 300);
      }
    },
    [employeeId, formData, fetchRoutesForCity, isTsmOrAbove, routes],
  );

  const fetchInitialData = useCallback(async () => {
    if (!employeeId || !mountedRef.current) {
      setError("Employee data not available");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const [team, prevRoutes] = await Promise.all([
        fetchTeamMembers(),
        fetchPreviousRoutes(),
      ]);

      if (!mountedRef.current) return;

      setTeamMembers(team);
      setPreviousRoutes(prevRoutes);

      if (isNewProgram) {
        setFormData({});
        setOriginalData({});
        setIsLoading(false);
        setApprovalStatus("pending");
        return;
      }

      const normalizedMonthYear = normalizeMonthYear(monthYearDisplay);

      const existing = await fetchWithAuth(
        `${BASE_URL}/api/tour-programs/tour-monthly?employee_id=${employeeId}&monthYear=${encodeURIComponent(
          normalizedMonthYear,
        )}`,
      );

      if (!mountedRef.current) return;
      if (
        existing &&
        Array.isArray(existing.entries) &&
        existing.entries.length > 0
      ) {
        setTourExists(true);
      } else {
        setTourExists(false);
      }
      // Determine approval status
      let status = "pending";
      if (existing) {
        if (existing.status) {
          const statusLower = String(existing.status).toLowerCase();
          if (statusLower === "approved") status = "approved";
        } else if (existing.approved_detail?.status) {
          const statusLower = String(
            existing.approved_detail.status,
          ).toLowerCase();
          if (statusLower === "approved") status = "approved";
        } else if (existing.approval_status) {
          const statusLower = String(existing.approval_status).toLowerCase();
          if (statusLower === "approved") status = "approved";
        } else if (existing.is_approved === true) status = "approved";
        else if (existing.approved === true) status = "approved";
        else if (existing.approved_by && existing.approved_date)
          status = "approved";
      }

      setApprovalStatus(status);

      const initFormData = {};
      const initOriginal = {};

      // ── Deduplication sets ────────────────────────────────────────────────
      // Always include the main employee so individual/Meeting rows preload
      const uniqueEmployees = new Set([Number(employeeId)]);
      const uniqueCityEmployeePairs = new Set();
      // ─────────────────────────────────────────────────────────────────────

      if (existing && Array.isArray(existing.entries)) {
        for (const program of existing.entries) {
          const dayId = new Date(program.working_date).getDate();

          if (dateOfJoining && new Date(program.working_date) < dateOfJoining) {
            continue;
          }

          // Parse values from API
          let workingWithValue = "";
          if (
            program.working_with_employee_id !== null &&
            program.working_with_employee_id !== undefined
          ) {
            workingWithValue = program.working_with_employee_id;
          }

          let secondaryWorkingWithValue = "";
          if (
            program.working_mode !== null &&
            program.working_mode !== undefined
          ) {
            secondaryWorkingWithValue = program.working_mode;
          }

          let cityValue = "";
          if (program.city_id !== null && program.city_id !== undefined) {
            cityValue = program.city_id;
          }

          let routeValue = "";
          if (program.route_id !== null && program.route_id !== undefined) {
            routeValue = program.route_id;
          }

          // Store in form data — remarks preserved from API
          initFormData[dayId] = {
            city: cityValue,
            route: routeValue,
            workingWith: workingWithValue,
            secondaryWorkingWith: secondaryWorkingWithValue,
            remarks:
              program.remarks === "Data Not Entered" ? "" : program.remarks,
            programId: program.id,
          };

          initOriginal[dayId] = { ...initFormData[dayId] };

          // ── Collect unique employees & city-employee pairs ────────────────
          if (workingWithValue) {
            const emp = Number(workingWithValue);
            if (Number.isFinite(emp) && emp !== 0) {
              uniqueEmployees.add(emp);
              if (cityValue) {
                uniqueCityEmployeePairs.add(`${emp}_${cityValue}`);
              }
            }
          }

          if (
            secondaryWorkingWithValue &&
            secondaryWorkingWithValue !== workingWithValue
          ) {
            const secEmp = Number(secondaryWorkingWithValue);
            if (Number.isFinite(secEmp) && secEmp !== 0) {
              uniqueEmployees.add(secEmp);
              if (cityValue) {
                uniqueCityEmployeePairs.add(`${secEmp}_${cityValue}`);
              }
            }
          }
          // ─────────────────────────────────────────────────────────────────
        }
      }

      // ── Single batched fetch — no duplicates ──────────────────────────────
      const [assignedResults, routeResults, prevRouteResults] =
        await Promise.all([
          // Assigned cities — once per unique employee
          Promise.all(
            Array.from(uniqueEmployees).map(async (emp) => {
              const cities = await fetchAssignedCities(emp);
              return { emp, cities };
            }),
          ),
          // Routes — once per unique employee+city pair
          Promise.all(
            Array.from(uniqueCityEmployeePairs).map(async (pair) => {
              const [emp, city] = pair.split("_");
              const fetchedRoutes = await fetchRoutesForCity(city, emp);
              return { emp: Number(emp), cityId: city, fetchedRoutes };
            }),
          ),
          // Previous routes — once per unique employee
          Promise.all(
            Array.from(uniqueEmployees).map(async (emp) => {
              const fetchedRoutes = await fetchPreviousRoutesForEmployee(emp);
              return { emp, fetchedRoutes };
            }),
          ),
        ]);

      if (!mountedRef.current) return;

      // ── Store all results in state (cache for interactive handlers) ───────
      const newAssignedCities = {};
      for (const { emp, cities } of assignedResults) {
        newAssignedCities[emp] = cities;
      }
      setAssignedCities((prev) => ({ ...prev, ...newAssignedCities }));

      const newRoutes = {};
      for (const { emp, cityId, fetchedRoutes } of routeResults) {
        newRoutes[`${emp}_${cityId}`] = fetchedRoutes;
      }
      setRoutes((prev) => ({ ...prev, ...newRoutes }));

      const newPrevRoutes = {};
      for (const { emp, fetchedRoutes } of prevRouteResults) {
        newPrevRoutes[emp] = fetchedRoutes;
      }
      setPreviousRoutesByEmployee((prev) => ({ ...prev, ...newPrevRoutes }));
      // ─────────────────────────────────────────────────────────────────────

      setFormData(initFormData);
      setOriginalData(initOriginal);
    } catch (err) {
      if (mountedRef.current) {
        console.error("fetchInitialData:", err);
        setError(err.message || "Failed to load data");
      }
    } finally {
      if (mountedRef.current) {
        setIsLoading(false);
      }
    }
  }, [
    employeeId,
    monthYearDisplay,
    fetchWithAuth,
    fetchAssignedCities,
    fetchRoutesForCity,
    fetchTeamMembers,
    fetchPreviousRoutes,
    isNewProgram,
    dateOfJoining,
    normalizeMonthYear,
    fetchPreviousRoutesForEmployee,
  ]);

  // ── Stable ref pattern: runs only when employeeId changes, avoids
  //    stale-closure issues without triggering re-run loops ──────────────────
  const fetchInitialDataRef = useRef(fetchInitialData);
  useEffect(() => {
    fetchInitialDataRef.current = fetchInitialData;
  }, [fetchInitialData]);

  useEffect(() => {
    if (!employeeId) return;
    fetchInitialDataRef.current();
  }, [employeeId]);
  // ──────────────────────────────────────────────────────────────────────────

  const handleChange = useCallback(
    (dayId, field, value) => {
      const dayData = daysArray.find((day) => day.id === dayId);
      if (dayData && dayData.isBeforeDoj) {
        return;
      }

      if (field === "workingWith") {
        handleWorkingWithChange(dayId, value);
      } else if (field === "secondaryWorkingWith") {
        handleSecondaryWorkingWithChange(dayId, value);
      } else if (field === "city") {
        const workingWithEmployeeId = formData[dayId]?.workingWith;
        handleCityChange(dayId, value, workingWithEmployeeId);
      } else {
        // Handles "remarks" and any other plain fields
        setFormData((prev) => ({
          ...prev,
          [dayId]: {
            ...prev[dayId],
            [field]: value,
          },
        }));
      }
    },
    [
      daysArray,
      formData,
      handleWorkingWithChange,
      handleCityChange,
      handleSecondaryWorkingWithChange,
    ],
  );

  const handleSubmit = useCallback(
    async (skipRefetch = false) => {
      if (!currentUser?.username || !mountedRef.current) {
        toast.warning("User information not available");
        return;
      }

      setIsSubmitting(true);
      try {
        const allEntries = daysArray
          .filter((day) => !day.isBeforeDoj)
          .map((day) => {
            const dayData = formData[day.id] || {};
            const routeId = dayData.route
              ? Number.parseInt(dayData.route)
              : null;
            const workingWithId =
              dayData.workingWith !== undefined &&
                dayData.workingWith !== null &&
                dayData.workingWith !== ""
                ? Number.parseInt(dayData.workingWith)
                : null;

            let cityId = dayData.city ? Number.parseInt(dayData.city) : null;
            if (!cityId && routeId) {
              const selectedRoute = previousRoutes.find(
                (r) => r.id === routeId,
              );
              if (selectedRoute) {
                cityId = selectedRoute.city_id;
              }
            }
            if (!cityId) {
              cityId = 0;
            }

            const entry = {
              working_date: formatDateForAPI(day.dateObj),
              // remarks now carries the employee-entered value (holiday, leave, etc.)
              remarks: dayData.remarks || "",
              route_id: routeId,
              city_id: cityId,
              working_with_employee_id: workingWithId,
              working_mode:
                dayData.secondaryWorkingWith !== undefined &&
                  dayData.secondaryWorkingWith !== null &&
                  dayData.secondaryWorkingWith !== ""
                  ? Number.parseInt(dayData.secondaryWorkingWith)
                  : workingWithId,
              is_sunday: day.day === "Sunday",
            };

            if (dayData.programId && !isNewProgram) {
              entry.tour_program_id = Number.parseInt(dayData.programId);
            }
            return entry;
          });

        const normalizedMonthYear = normalizeMonthYear(monthYearDisplay);

        const payload = {
          employee_id: Number.parseInt(employeeId),
          month_year: normalizedMonthYear,
          tour_data: allEntries,
        };

        const method = isNewProgram ? "POST" : "PUT";
        const response = await fetchWithAuth(
          `${BASE_URL}/api/tour-programs/tour-monthly`,
          {
            method: method,
            headers: {
              "X-User-Name": currentUser.username,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        );

        if (!mountedRef.current) return;

        if (response && response.message) {
          toast.success(response.message);
        } else {
          toast.success(
            isNewProgram
              ? "Tour program created successfully."
              : "Tour program updated successfully.",
          );
        }

        if (!skipRefetch) {
          await fetchInitialData();
        }
      } catch (err) {
        if (mountedRef.current) {
          console.error("handleSubmit:", err);
          toast.error(err.message || "Failed to save tour program");
        }
      } finally {
        if (mountedRef.current) {
          setIsSubmitting(false);
        }
      }
    },
    [
      currentUser,
      daysArray,
      formData,
      previousRoutes,
      employeeId,
      monthYearDisplay,
      isNewProgram,
      formatDateForAPI,
      fetchWithAuth,
      fetchInitialData,
      normalizeMonthYear,
    ],
  );

  const handleApprove = useCallback(async () => {
    if (!currentUser?.username || !mountedRef.current) {
      toast.warning("User information not available");
      return;
    }

    if (approvalStatus === "approved") {
      toast.info("Month is already approved");
      return;
    }

    setIsSubmitting(true);
    try {
      // Save the latest form data (including remarks) before approving
      await handleSubmit(true);

      const monthYear = new Intl.DateTimeFormat("en", {
        month: "short",
        year: "numeric",
      }).format(new Date(`${selectedYear}-${selectedMonth}-01`));
      const normalizedMonthYear = normalizeMonthYear(monthYear);

      // Build the full tour_data with remarks so the approval payload is complete
      const allEntries = daysArray
        .filter((day) => !day.isBeforeDoj)
        .map((day) => {
          const dayData = formData[day.id] || {};
          const routeId = dayData.route
            ? Number.parseInt(dayData.route)
            : null;
          const workingWithId =
            dayData.workingWith !== undefined &&
              dayData.workingWith !== null &&
              dayData.workingWith !== ""
              ? Number.parseInt(dayData.workingWith)
              : null;

          let cityId = dayData.city ? Number.parseInt(dayData.city) : null;
          if (!cityId && routeId) {
            const selectedRoute = previousRoutes.find((r) => r.id === routeId);
            if (selectedRoute) {
              cityId = selectedRoute.city_id;
            }
          }
          if (!cityId) {
            cityId = 0;
          }

          const entry = {
            working_date: formatDateForAPI(day.dateObj),
            remarks: dayData.remarks || "",
            route_id: routeId,
            city_id: cityId,
            working_with_employee_id: workingWithId,
            working_mode:
              dayData.secondaryWorkingWith !== undefined &&
                dayData.secondaryWorkingWith !== null &&
                dayData.secondaryWorkingWith !== ""
                ? Number.parseInt(dayData.secondaryWorkingWith)
                : workingWithId,
            is_sunday: day.day === "Sunday",
          };

          if (dayData.programId && !isNewProgram) {
            entry.tour_program_id = Number.parseInt(dayData.programId);
          }
          return entry;
        });

      const payload = {
        monthYear: normalizedMonthYear,
        status: "approved",
        remarks: "Monthly plan approved",
        // Include full tour data with per-day remarks in approval payload
        tour_data: allEntries,
      };

      console.log("Sending approval request with payload:", payload);

      const response = await fetchWithAuth(
        `${BASE_URL}/api/tour-programs/employee/${employeeId}/approve`,
        {
          method: "PUT",
          headers: {
            "X-User-Name": currentUser.username,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (!mountedRef.current) return;
      if (response?.message) {
        toast.success(response.message);
      } else if (response?.status) {
        toast.success(`Monthly plan ${response.status}`);
      } else {
        toast.success("Monthly plan approved successfully");
      }

      setApprovalStatus("approved");
      await fetchInitialData();
    } catch (err) {
      if (mountedRef.current) {
        console.error("handleApprove error:", err);
        toast.error(err.message || "Failed to approve monthly plan");
      }
    } finally {
      if (mountedRef.current) {
        setIsSubmitting(false);
      }
    }
  }, [
    currentUser,
    selectedYear,
    selectedMonth,
    employeeId,
    fetchWithAuth,
    fetchInitialData,
    normalizeMonthYear,
    handleSubmit,
    approvalStatus,
    daysArray,
    formData,
    previousRoutes,
    isNewProgram,
    formatDateForAPI,
  ]);

  const handleReturn = useCallback(() => {
    const preservedState = location.state?.preservedState || {};
    navigate("/tour-program", {
      state: { preservedState },
      replace: true,
    });
  }, [location.state?.preservedState, navigate]);

  return (
    <div className="">
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25">
          <Loader onCancel={() => setIsLoading(false)} />
        </div>
      )}
      <div
        className={`main-container ${isLoading || isSubmitting ? "blur-sm pointer-events-none" : ""
          }`}
      >
        <div className="tourpage-container">
          <div className="flex justify-center mb-5">
            <h2 className="whitespace-nowrap">
              {employeeData.name || "Employee"} (
              {employeeData.designation || "Designation"} |{" "}
              {employeeData.headquarter || "HQ"} |{" "}
              {employeeData.division || "Division"} |{" "}
              {employeeData.state || "State"}) Tour Program – {monthYearDisplay}
              {dateOfJoining ? (
                <span
                  style={{
                    color: "red",
                    fontSize: "0.8em",
                    marginLeft: "10px",
                  }}
                >
                  (Date of Joining: {dateOfJoining.toLocaleDateString("en-GB")})
                </span>
              ) : (
                <span
                  style={{
                    color: "orange",
                    fontSize: "0.8em",
                    marginLeft: "10px",
                  }}
                >
                  (Date of Joining: Not Available)
                </span>
              )}
            </h2>
          </div>

          <div style={{ overflowX: "auto", width: "100%" }}>
            <table
              className="tourpage-table"
              style={{
                tableLayout: "auto",
                width: "100%",
                minWidth: isTsmOrAbove ? 1300 : 760,
              }}
            >
              <thead className="bg-blue-600 text-white sticky top-0 z-10 shadow-sm">
                <tr>
                  <th style={{ whiteSpace: "nowrap", width: 50 }}>S.No</th>
                  <th style={{ whiteSpace: "nowrap", minWidth: 190 }}>
                    Working Date &amp; Day
                  </th>
                  {isTsmOrAbove ? (
                    <>
                      <th style={{ minWidth: 180 }}>Working With</th>
                      <th style={{ minWidth: 160 }}>Route Owner</th>
                      <th style={{ minWidth: 130 }}>City</th>
                      <th style={{ minWidth: 140 }}>Routes</th>
                      <th style={{ minWidth: 200 }}>Remarks</th>
                    </>
                  ) : (
                    <>
                      <th style={{ minWidth: 200 }}>Working With</th>
                      <th style={{ minWidth: 160 }}>Routes</th>
                      <th style={{ minWidth: 200 }}>Remarks</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {daysArray.map((day) => {
                  const formDay = formData[day.id] || {};
                  const isSunday = day.day === "Sunday";
                  const isBeforeDoj = day.isBeforeDoj;
                  const isIndividualSelected =
                    Number(formDay.workingWith) === Number(employeeId);

                  // For smaller roles (ASE, MR), always use their own ID
                  const effectiveEmpForPrevRoutes = !isTsmOrAbove
                    ? Number(employeeId)
                    : (() => {
                      if (
                        Number(formDay.workingWith) === Number(employeeId) &&
                        formDay.secondaryWorkingWith
                      ) {
                        return Number(formDay.secondaryWorkingWith);
                      }
                      if (formDay.workingWith)
                        return Number(formDay.workingWith);
                      return Number(employeeId);
                    })();

                  const sundayRoutes =
                    previousRoutesByEmployee[effectiveEmpForPrevRoutes] ||
                    previousRoutes ||
                    [];

                  const effectiveEmpForCity = !isTsmOrAbove
                    ? Number(employeeId)
                    : (() => {
                      if (
                        Number(formDay.workingWith) === Number(employeeId) &&
                        formDay.secondaryWorkingWith
                      ) {
                        return Number(formDay.secondaryWorkingWith);
                      }
                      if (formDay.workingWith && formDay.workingWith !== "")
                        return Number(formDay.workingWith);
                      return Number(employeeId);
                    })();

                  const cityKey = formDay.city
                    ? `${effectiveEmpForCity}_${String(formDay.city)}`
                    : null;
                  const routesForCity = cityKey ? routes[cityKey] || [] : [];

                  const citiesForEmployee =
                    formDay.workingWith && formDay.workingWith !== 0
                      ? assignedCities[effectiveEmpForCity] || []
                      : formDay.workingWith === 0
                        ? assignedCities[0] || []
                        : [];

                  const rowClass = isSunday
                    ? "tourpage-sunday-row"
                    : isBeforeDoj
                      ? "tourpage-disabled-row"
                      : "";

                  return (
                    <tr key={day.id} className={rowClass}>
                      <td>{day.id}</td>
                      <td>
                        {day.dateObj.toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })}{" "}
                        ({day.day})
                        {isBeforeDoj && (
                          <span style={{ color: "red", marginLeft: "5px" }}>
                            (Before DOJ)
                          </span>
                        )}
                      </td>

                      {isTsmOrAbove ? (
                        <>
                          <td>
                            <select
                              className="tourpage-dropdown"
                              value={formDay.workingWith ?? ""}
                              onChange={(e) =>
                                handleChange(
                                  day.id,
                                  "workingWith",
                                  e.target.value,
                                )
                              }
                              disabled={isBeforeDoj}
                            >
                              <option value="">Select</option>
                              {teamMembers.map((member) => {
                                const label =
                                  member.employee_id === 0
                                    ? "Meeting"
                                    : member.employee_id === employeeId
                                      ? `individual`
                                      : `${member.first_name} ${member.last_name} (${member.designation} | ${member.city_name} | ${member.state_name})`;
                                return (
                                  <option
                                    key={member.employee_id}
                                    value={member.employee_id}
                                  >
                                    {label}
                                  </option>
                                );
                              })}
                            </select>
                          </td>
                          <td>
                            <select
                              className="tourpage-dropdown"
                              value={formDay.secondaryWorkingWith ?? ""}
                              onChange={(e) =>
                                handleChange(
                                  day.id,
                                  "secondaryWorkingWith",
                                  e.target.value,
                                )
                              }
                              disabled={isBeforeDoj || !isIndividualSelected}
                            >
                              <option value="">Select</option>
                              {teamMembers.map((member) => {
                                const label =
                                  member.employee_id === 0
                                    ? "Meeting"
                                    : member.employee_id === employeeId
                                      ? `individual`
                                      : `${member.first_name} ${member.last_name} (${member.designation} | ${member.city_name} | ${member.state_name})`;
                                return (
                                  <option
                                    key={member.employee_id}
                                    value={member.employee_id}
                                  >
                                    {label}
                                  </option>
                                );
                              })}
                            </select>
                          </td>
                          <td>
                            <select
                              className="tourpage-dropdown"
                              value={formDay.city || ""}
                              onChange={(e) =>
                                handleChange(day.id, "city", e.target.value)
                              }
                              disabled={
                                isBeforeDoj ||
                                (!formDay.workingWith &&
                                  formDay.workingWith !== 0 &&
                                  !isSunday)
                              }
                            >
                              <option value="">Select City</option>
                              {citiesForEmployee.map((city) => (
                                <option key={city.city_id} value={city.city_id}>
                                  {city.city_name}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <select
                              className="tourpage-dropdown"
                              value={formDay.route || ""}
                              onChange={(e) =>
                                handleChange(day.id, "route", e.target.value)
                              }
                              disabled={
                                isBeforeDoj ||
                                (!formDay.city && !isSunday) ||
                                (!formDay.workingWith &&
                                  formDay.workingWith !== 0 &&
                                  !isSunday)
                              }
                            >
                              <option value="">Select Route</option>
                              {(isSunday ? sundayRoutes : routesForCity).map(
                                (route) => (
                                  <option key={route.id} value={route.id}>
                                    {route.name || route.route_name}
                                  </option>
                                ),
                              )}
                            </select>
                          </td>
                          {/* ── Remarks column — TSM & above ── */}
                          <RemarksCell
                            value={formDay.remarks || ""}
                            onChange={(val) =>
                              handleChange(day.id, "remarks", val)
                            }
                            disabled={isBeforeDoj}
                          />
                        </>
                      ) : (
                        <>
                          <td>
                            <select
                              className="tourpage-dropdown"
                              value={formDay.workingWith ?? ""}
                              onChange={(e) =>
                                handleChange(
                                  day.id,
                                  "workingWith",
                                  e.target.value,
                                )
                              }
                              disabled={isBeforeDoj}
                            >
                              <option value="">Select</option>
                              {teamMembers.map((member) => {
                                const label =
                                  member.employee_id === 0
                                    ? "Meeting"
                                    : member.employee_id === employeeId
                                      ? `individual`
                                      : `${member.first_name} ${member.last_name} (${member.designation} | ${member.city_name} | ${member.state_name})`;
                                return (
                                  <option
                                    key={member.employee_id}
                                    value={member.employee_id}
                                  >
                                    {label}
                                  </option>
                                );
                              })}
                            </select>
                          </td>
                          <td>
                            <select
                              className="tourpage-dropdown"
                              value={formDay.route || ""}
                              onChange={(e) =>
                                handleChange(day.id, "route", e.target.value)
                              }
                              disabled={isBeforeDoj}
                            >
                              <option value="">Select Route</option>
                              {(sundayRoutes || []).map((route) => (
                                <option key={route.id} value={route.id}>
                                  {route.name || route.route_name}
                                </option>
                              ))}
                            </select>
                          </td>
                          {/* ── Remarks column — ASE / MR and below ── */}
                          <RemarksCell
                            value={formDay.remarks || ""}
                            onChange={(val) =>
                              handleChange(day.id, "remarks", val)
                            }
                            disabled={isBeforeDoj}
                          />
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>{/* end overflow-x scroll wrapper */}

          <div
            className="tourpage-buttons"
            style={{ display: "flex", gap: 8, alignItems: "center" }}
          >
            <CustomButton
              variant="save"
              onClick={() => handleSubmit()}
              disabled={isSubmitting || !currentUser}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Submitting...
                </>
              ) : (
                "Submit"
              )}
            </CustomButton>

            <CustomButton variant="cancel" onClick={handleReturn}>
              Return
            </CustomButton>

            {approvalStatus !== "approved" && (
              <CustomButton
                className="whitespace-nowrap"
                variant="save"
                onClick={handleApprove}
                disabled={isSubmitting || !currentUser || isNewProgram}
              >
                Approve
              </CustomButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourProgramModified;